const itemSelectorElement = document.getElementById('test-new-item-selector');
const itemSelectorElementPreselected = document.getElementById('test-preselected-item-selector');
const itemSelectorFormData = document.getElementById('ex1-form-data');
const itemSelectorFormDataPreselected = document.getElementById('ex2-form-data');

itemSelectorElement.addEventListener('selectionSaved', function(event) {
  if ((event as any).detail) {
    console.log((event as any).detail);
    itemSelectorFormData.innerText = JSON.stringify((event as any).detail);
  }
});

itemSelectorElementPreselected.addEventListener('selectionSaved', function(event) {
  if ((event as any).detail) {
    console.log((event as any).detail);
    itemSelectorFormDataPreselected.innerText = JSON.stringify((event as any).detail);
  }
});
